export const tableColumns = [
  { title: 'Produit' },
  { title: 'Quantité', classes: 'text-center vertical-center' },
  { title: '', width: '60px' }
]